import { createPortal } from 'react-dom';

import { SafeHtml } from '@bcp-channels-sharedcomponents-reactjs/core';
import { Box, Button, ComposableTypography, useBreakpoint } from '@bcp-nextgen-dx-component-factory/design-system';
import { css } from '@emotion/css';
import { UIHelper } from '@helpers';
import { useCookiesConsent, useDrawer, useModal, useTranslation } from '@hooks';

import { Modals } from '..';

const MODAL_NAME: Modals = 'cookiesConsent';

export const CookiesConsentModal = () => {
	const { t } = useTranslation();
	const breakpoint = useBreakpoint();
	const modal = useModal(MODAL_NAME);
	const drawer = useDrawer('cookiesPreferences');
	const { handleAcceptAllCookies, handleRejectAllCookies } = useCookiesConsent();

	const handleManagePreferences = () => {
		drawer.show();
		modal.hide();
	};

	if (!modal.isVisible) {
		return null;
	}

	return createPortal(
		<Box
			styles={{
				zIndex: 2,
				position: 'fixed',
				right: 0,
				left: breakpoint === 'desktop' ? undefined : 0,
				bottom: 0,
				margin: UIHelper.rem(24),
				flexDirection: 'column',
				background: '#fff',
				padding: UIHelper.rem(40, 32),
				borderRadius: '24px',
				boxShadow: '0px 16px 32px 0px rgba(46, 54, 65, 0.08)',
				maxWidth: breakpoint === 'desktop' ? UIHelper.rem(662) : undefined,
			}}
		>
			<Box
				styles={{
					flexDirection: 'column',
					gap: UIHelper.rem(16),
				}}
			>
				<ComposableTypography
					baseProps={{
						appearance: 'subtitle-100-04',
					}}
					text={t('modals.cookiesConsent.title')}
					tags={{}}
				/>

				{/* Not possible to use an <a></a> with CF ComposableTypography */}
				<div
					className={css`
						> div {
							font-size: 16px;
							font-weight: 500;
							color: #80828f;

							> a {
								font-weight: 600;
								color: #d1005d;
							}
						}
					`}
				>
					<SafeHtml allowedAttributes={['href', 'target']} html={t('modals.cookiesConsent.message')} />
				</div>
			</Box>

			{/* ACTIONS */}
			<Box
				styles={{
					gap: UIHelper.rem(16),
					marginTop: UIHelper.rem(32),
					flexWrap: 'wrap',
				}}
			>
				<Button onPress={handleAcceptAllCookies}>{t('modals.cookiesConsent.button.acceptAll')}</Button>
				<Button onPress={handleRejectAllCookies}>{t('modals.cookiesConsent.button.rejectAll')}</Button>

				{/* CF Button should not have padding when appearance ghost */}
				<div
					className={css`
						margin-left: auto;
						> button {
							padding: 0;
						}
					`}
				>
					<Button variant="tertiary" onPress={handleManagePreferences}>
						{t('modals.cookiesConsent.button.managePreferences')}
					</Button>
				</div>
			</Box>
		</Box>,
		document.body
	);
};
